export default {
    PI_UBI_01: {
        code: 'PI-UBI-01',
        helpshiftLink:
            'https://epicgames.helpshift.com/a/epic-games-store-and-launcher/?s=error-codes&f=pi-ubi-01&p=all'
    }
};
